import React, { Component } from 'react';
import './Wave.scss'

class Wave extends Component {
	render() {
		return (
			<div className={`${this.props.className} ocean`}>
				<div className={`${this.props.className} wave`}></div>
				<div className={`${this.props.className} wave`}></div>
				<div className={`${this.props.className} wave`}></div>
			</div>
		);
	}
}

export default Wave;


// WEBPACK FOOTER //
// ./src/Components/Wave.js